module.exports = __webpack_public_path__ + "media/search.png";